import { useEffect } from "react"
import { AUTH_STORAGE_KEYS } from "@/shared/config/auth"

export function ClientErrorReporter() {
	useEffect(() => {
		function send(payload: Record<string, unknown>) {
			try {
				const token = sessionStorage.getItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN)
				if (!token) return

				const body = JSON.stringify({
					...payload,
					userAgent: navigator.userAgent,
					url: location.href,
				})

				fetch("/api/log-error", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
					body,
					keepalive: true,
				}).catch(() => {})
			} catch {}
		}

		function onError(e: ErrorEvent) {
			send({
				source: "window.onerror",
				message: e.message,
				stack: e.error?.stack,
			})
		}

		function onUnhandled(e: PromiseRejectionEvent) {
			const err = e.reason
			send({
				source: "unhandledrejection",
				message: err instanceof Error ? err.message : String(err),
				stack: err instanceof Error ? err.stack : undefined,
			})
		}

		window.addEventListener("error", onError)
		window.addEventListener("unhandledrejection", onUnhandled)

		return () => {
			window.removeEventListener("error", onError)
			window.removeEventListener("unhandledrejection", onUnhandled)
		}
	}, [])

	return null
}
